export const isGbrAddress = (address) => address.post_town !== undefined;
